import { Dispatch, ReactNode, SetStateAction } from "react";
import { OptionMenuItem } from "../../../../../components/ui/OptionMenu";
import { ConfirmedDeal } from "../../../../../types/empresa";
import { VisitaDetails } from "../../../../visitas/VisitaDetails/components/VisitaDetails";
import EditRoundedIcon from '@mui/icons-material/EditRounded';

interface Props {
    deal: ConfirmedDeal;
    setCurrentOption: Dispatch<SetStateAction<ReactNode | null>>
    setShowEditModal: Dispatch<SetStateAction<boolean>>
}

export function EditVisitOption({ deal, setShowEditModal, setCurrentOption }: Props) {

    const handleOnClick = () => {
        setCurrentOption(
            <div className="flex flex-col p-3 h-sfull h-[700px] ">
                <VisitaDetails 
                    visitaId={deal.id}
                    onCancel={() => setShowEditModal(false)}
                    disableFinishButton/>
            </div>);
    }

    return (
        <OptionMenuItem onClick={handleOnClick}>
            <EditRoundedIcon sx={{ height: 20, width: 20 }}/>
            <p className="text-sm font-semibold text-center">Editar visita</p>
        </OptionMenuItem>
    );
}
